import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { PlanTypes } from 'Interfaces/Billing';
import { UnauthorizedRoutePaths } from 'Interfaces/RoutePaths';
import { GuestWrapper } from 'Layouts/GuestWrapper';
import RootWrapper from 'Layouts/RootWrapper';
import SimplifiedWrapper from 'Layouts/SimplifiedWrapper';
import { AboutSignaturely } from 'Pages/AboutSignaturely';
import * as Auth from 'Pages/Auth';

import BaseRoutes from './BaseRoutes';
import CustomRedirect from './CustomRedirect';

const UnauthorizedRoutes = createBrowserRouter([
  {
    path: '/',
    element: <RootWrapper />,
    children: [
      { index: true, element: <CustomRedirect to={UnauthorizedRoutePaths.LOGIN} /> },
      ...BaseRoutes,
      { path: UnauthorizedRoutePaths.SIGN_UP, element: <Auth.SignUpFirstStep /> },
      {
        path: UnauthorizedRoutePaths.SIGN_UP_FREE,
        element: <Auth.SignUpFirstStep isFreeSignUp />,
      },
      {
        path: UnauthorizedRoutePaths.CONFIRM_ACCOUNT,
        element: <SimplifiedWrapper />,
        children: [{ index: true, element: <Auth.ConfirmPage /> }],
      },
      {
        path: UnauthorizedRoutePaths.CHANGE_PASSWORD,
        element: <SimplifiedWrapper />,
        children: [{ index: true, element: <Auth.ChangePassword /> }],
      },
      {
        path: UnauthorizedRoutePaths.LOGIN,
        element: <SimplifiedWrapper />,
        children: [{ index: true, element: <Auth.Login /> }],
      },
      {
        path: UnauthorizedRoutePaths.SIGN_UP_BUSINESS,
        element: <SimplifiedWrapper />,
        children: [
          { index: true, element: <Auth.BuyNow currentPlan={PlanTypes.BUSINESS} /> },
        ],
      },
      {
        path: UnauthorizedRoutePaths.SIGN_UP_PERSONAL,
        element: <SimplifiedWrapper />,
        children: [
          { index: true, element: <Auth.BuyNow currentPlan={PlanTypes.PERSONAL} /> },
        ],
      },
      {
        path: UnauthorizedRoutePaths.TWO_FACTOR,
        element: <SimplifiedWrapper />,
        children: [{ index: true, element: <Auth.TwoFactor /> }],
      },
      {
        path: UnauthorizedRoutePaths.ABOUT,
        element: <GuestWrapper isShowFooter isShowHeaderBorder />,
        children: [{ index: true, element: <AboutSignaturely /> }],
      },
      { path: '*', element: <CustomRedirect to={UnauthorizedRoutePaths.LOGIN} /> },
    ],
  },
]);

export default UnauthorizedRoutes;
